import type { Metric } from "web-vitals";

type WebVitalsModule = {
  onCLS: (onPerfEntry: (metric: Metric) => void) => void;
  onINP: (onPerfEntry: (metric: Metric) => void) => void;
  onFCP: (onPerfEntry: (metric: Metric) => void) => void;
  onLCP: (onPerfEntry: (metric: Metric) => void) => void;
  onTTFB: (onPerfEntry: (metric: Metric) => void) => void;
};

export function registerWebVitals(
  onPerfEntry: (metric: Metric) => void,
  webVitals: WebVitalsModule,
): void {
  webVitals.onCLS(onPerfEntry);
  webVitals.onINP(onPerfEntry);
  webVitals.onFCP(onPerfEntry);
  webVitals.onLCP(onPerfEntry);
  webVitals.onTTFB(onPerfEntry);
}

const reportWebVitals = (
  onPerfEntry?: (metric: Metric) => void,
  webVitalsModule: WebVitalsModule = require("web-vitals"),
): void => {
  if (onPerfEntry && typeof onPerfEntry === "function") {
    registerWebVitals(onPerfEntry, webVitalsModule);
  }
};

export default reportWebVitals;
